import styles from './CartOrderSummary.module.scss'

import { CartContext } from '../../../contexts/CartContext'
import { formatPrice } from '../../../utils/pricingUtils'

const checkoutPath = '/cart/checkout'

export function CartOrderSummary() {

  return (
    <CartContext.Consumer>
      {({cart}) => {
        const nextStepButton = cart.meta.count ? <a href={ checkoutPath }><button className={styles.btn}>CHECKOUT</button></a> : null

        const containerStyles = [ styles.container ]
        if (cart?.loading) containerStyles.push(styles.loading)

        return (
          <div className={ containerStyles.join(' ') }>
            <div className={ styles.cartOrderSummary }>
              <div className={ styles.title }>Order Summary</div>
              <div>
                <div>
                  <span>Subtotal:</span>
                  <span>£{ formatPrice(cart.meta.total_price) }</span>
                </div>
              </div>
              <div className={ styles.total }>
                <div>
                  <span>Total:</span>
                  <span>£{ formatPrice(cart.meta.total_price) }</span>
                </div>
              </div>
            </div>
            { nextStepButton }
          </div>
        )
      }}
    </CartContext.Consumer>
  )
}
